import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserLanguagePreferenceQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
  tagId: Types.Scalars['String']['input'];
}>;


export type UserLanguagePreferenceQuery = { user?: { id: string, tag?: { tagId: string, optionIdValues?: Array<string> | null } | null } | null };


export const UserLanguagePreferenceDocument = /*#__PURE__*/ gql`
    query UserLanguagePreference($filters: UserFilters!, $tagId: String!) {
  user(filters: $filters) {
    id
    tag(tagId: $tagId) {
      tagId
      optionIdValues
    }
  }
}
    `;

export function useUserLanguagePreferenceQuery(options: Omit<Urql.UseQueryArgs<UserLanguagePreferenceQueryVariables>, 'query'>) {
  return Urql.useQuery<UserLanguagePreferenceQuery, UserLanguagePreferenceQueryVariables>({ query: UserLanguagePreferenceDocument, ...options });
};